import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TbTriangleSquareCircle, TbTableDashed } from "react-icons/tb";
import { LayoutGrid, ListTodo, MessageCircle, Bot } from "lucide-react";
import { openAgentStudio } from "../../config/environment";
import { useAuth } from "../Context/authContext";

const Sidebar = ({ isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleAgentStudioNavigation = async () => {
    // Check if user is authenticated before opening Agent Studio
    if (!user) {
      alert('Please login to access Agent Studio');
      navigate('/login');
      return;
    }
    
    // Prepare auth data for transfer to Agent Studio
    try {
      const token = localStorage.getItem('token');
      const first_name = localStorage.getItem('first_name');
      const last_name = localStorage.getItem('last_name');
      const userEmail = localStorage.getItem('userEmail');
      const refreshToken = localStorage.getItem('refreshToken');
      const userId = localStorage.getItem('userId');
      const api_key = localStorage.getItem('api_key');
      
      if (!token) {
        console.warn('No token found, user may need to re-login');
        alert('Session expired. Please login again.');
        navigate('/login');
        return;
      }
      
      const userData = {
        name: first_name + ' ' + last_name,
        organization: "Fouray's organization",
        plan: 'Community Plan',
        email: user.email || userEmail,
        first_name: first_name,
        last_name: last_name,
      };
      
      // Prepare complete auth data for transfer
      const authData = {
        token: token,
        first_name: first_name,
        last_name: last_name,
        userEmail: userEmail,
        api_key: api_key,
        refreshToken: refreshToken,
        userId: userId,
        userData: userData,
        timestamp: Date.now()
      };
      
      console.log('Transferring auth data to Agent Studio:', authData);
      
      // Open Agent Studio with auth data
      openAgentStudio(authData);
      
    } catch (error) {
      console.error('Error preparing auth data:', error);
      alert('Error preparing Agent Studio. Please try again.');
      return;
    }
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`} style={{ zIndex: 999 }}>
      <ul className="nav-list">
        <li
          className={`nav-item ${
            location.pathname === "/" ? "active-sidebar" : ""
          }`}
          onClick={() => handleNavigation("/")}
        >
          <TbTableDashed className="nav-icon" />
          {isOpen && <span className="nav-des">Dashboard</span>}
        </li>

        <li
          className={`nav-item ${
            location.pathname === "/skills" ? "active-sidebar" : ""
          }`}
          onClick={() => handleNavigation("/skills")}
        >
          <LayoutGrid className="nav-icon" />
          {isOpen && <span className="nav-des">Skills</span>}
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/tasks" ? "active-sidebar" : ""
          }`}
          onClick={() => handleNavigation("/tasks")}
        >
          <ListTodo className="nav-icon" />
          {isOpen && <span className="nav-des">Task</span>}
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/skills/chat" ? "active-sidebar" : ""
          }`}
          onClick={() => handleNavigation("/skills/chat")}
        >
          <MessageCircle className="nav-icon" />
          {isOpen && <span className="nav-des">Chat</span>}
        </li>
        <li
          className="nav-item"
          onClick={handleAgentStudioNavigation}
        >
          <Bot className="nav-icon" />
          {isOpen && <span className="nav-des">Agent Studio</span>}
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
